


























































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Route } from 'vue-router'
import { Form as ElForm, Input } from 'element-ui'
import { UserModule } from '../../store/modules/user'
import { isValidUsername } from '@/utils/validate'
import { getVerifyCode, } from '@/api/adminuser'

@Component({
  name: 'Login',
})
export default class extends Vue {
  private validateUsername = (rule: any, value: string, callback: Function) => {
    if (!value) {
      callback(new Error('请输入用户名'))
    } else {
      callback()
    }
  }
  private validatePassword = (rule: any, value: string, callback: Function) => {
    if (value.length < 6) {
      callback(new Error('密码必须在6位以上'))
    } else {
      callback()
    }
  }

  private validateCode = (rule: any, value: string, callback: Function) => {
    if (!value) {
      callback(new Error('请输入验证码'))
    } else {
      callback()
    }
  }
  private loginForm = {
    username : "",
    password : "",
    code : "",
    captcha: '',
  }

  loginRules = {
    username: [{ validator: this.validateUsername, trigger: 'blur' }],
    password: [{ validator: this.validatePassword, trigger: 'blur' }],
    code: [{ validator: this.validateCode, trigger: 'blur' }],
  }
  private loading = false
  private redirect?: string

  @Watch('$route', { immediate: true })
  private onRouteChange(route: Route) {}

  // 登录
  private handleLogin() {
    ;(this.$refs.loginForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true
        await UserModule.Login(this.loginForm as any)
          .then((res: any) => {
            if (String(res.code) === '1') {
              this.$router.push('/dashboard')
            } else {
              this.chagneCaptcha()
              // this.$message.error(res.msg)
              this.loading = false
            }
          })
          .catch(() => {
            this.chagneCaptcha()
            // this.$message.error('用户名或密码错误！')
            this.loading = false
          })
      } else {
        return false
      }
    })
  }
  async chagneCaptcha() {
    const res = await getVerifyCode()
    this.loginForm.captcha = URL.createObjectURL(new Blob([res.data], {type: 'image/png'}))
  }

  created(){
    this.chagneCaptcha()
  }
  destroyed(){
    //释放这个URL资源以防止内存泄漏
    if(this.loginForm.captcha && URL.revokeObjectURL){
      URL.revokeObjectURL(this.loginForm.captcha)
    }
  }
}
